"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _basic_provider = _interopRequireDefault(require("./_basic_provider"));
var _error = require("./error");
var _lodash = _interopRequireDefault(require("lodash"));
class ContactsApi extends _basic_provider.default {
  /**
   * Represents a Contact Api.
   * @constructor
   */
  constructor(_ref) {
    let {
      userTokenFactory,
      sdkApiUrl,
      providersAccountId,
      httpGatewayUrl,
      sendWSMessage,
      globalCache = false
    } = _ref;
    super({
      userTokenFactory,
      sdkApiUrl,
      providersAccountId,
      httpGatewayUrl,
      sendWSMessage,
      globalCache
    });
  }

  /**
   *
   * @param {Object} param0.options options for request - {size, from, sort, projection, bookName, tableName, bookAccountId}
   * @returns {Object} with properties data: contacts list, total: contacts count
   */
  async getContactsList(options) {
    return await this._callApi({
      method: 'get',
      path: '/contacts',
      queryParams: options,
      errorName: 'ContactError'
    });
  }

  /**
   *
   * @description This method fetches the list of Contacts from specific provider with MarvinDev AccountId
   * Will be deleted after Contacts API allows support of cross-account calls
   * @param {Object} param0.options options for request - {size, from, sort, scroll, scroll_id, projection}
   * @returns {Array} of contacts list
   */
  async getContacts(options) {
    return await this._callApi({
      method: 'get',
      path: 'contacts/list-all',
      queryParams: options,
      errorName: 'ContactError'
    });
  }

  /**
   *
   * @param {String} param0.contactId id of contact
   * @param {String} param1.bookName name of contact book
   * @param {Boolean} param2.useAlias if true - match contactId with aliases
   * @returns {Object} contact
   */
  async getContact(_ref2) {
    let {
      contactId,
      bookName,
      useAlias
    } = _ref2;
    return await this._callApi({
      method: 'get',
      path: '/contacts',
      queryParams: {
        contactId,
        bookName,
        useAlias
      },
      errorName: 'ContactError'
    });
  }

  /**
   *
   * @param {String} param0.contactId id of contact
   * @param {Array} param1.contactIds array of contact ids
   * @param {String} param2.bookName name of contact book
   */
  async deleteContact(_ref3) {
    let {
      contactId,
      contactIds,
      bookName
    } = _ref3;
    if (contactIds.length > 100) {
      const batches = [];
      for (let i = 0; i < contactIds.length; i += 100) {
        const batch = contactIds.slice(i, i + 100);
        batches.push(batch);
      }
      let responce;
      for (const batch of batches) {
        try {
          responce = await this._callApi({
            method: 'delete',
            path: '/contacts',
            queryParams: {
              contactIds: batch,
              bookName
            },
            errorName: 'ContactError'
          });
        } catch (error) {
          throw new _error.BasicError(error, {
            statusCode: _lodash.default.get(error, 'response.status')
          }, {
            name: 'ContactError'
          });
        }
      }
      return responce;
    }
    return await this._callApi({
      method: 'delete',
      path: '/contacts',
      queryParams: {
        contactId,
        contactIds,
        bookName
      },
      errorName: 'ContactError'
    });
  }

  /**
   *
   * @param {Object} param0.contactData contact object with required fields contactId
   * @param {String} param1.bookName name of contact book
   * @param {Object} param2.returning return undated contact in response
   */
  async updateContact(_ref4) {
    let {
      contactData,
      bookName,
      returning = false
    } = _ref4;
    if (!_lodash.default.has(contactData, 'contactId')) {
      throw new Error('ContactId is required in contact data');
    }
    return await this._callApi({
      method: 'put',
      path: '/contacts',
      queryParams: {
        returning,
        bookName
      },
      payload: contactData,
      errorName: 'ContactError'
    });
  }

  /**
   *
   * @param {Object} param0.contactData contact object with required fields contactId
   * @param {String} param1.bookName name of contact book
   * @param {Object} param2.returning return undated contact in response
   */
  async patchContact(_ref5) {
    let {
      patchContactData,
      bookName,
      returning = false
    } = _ref5;
    if (!_lodash.default.has(patchContactData, 'contactId')) {
      throw new Error('ContactId is required in contact data');
    }
    const {
      contactId
    } = patchContactData;
    const contactData = await this.getContact({
      contactId,
      bookName
    });
    if (_lodash.default.isEmpty(contactData)) {
      throw new Error('Contact not found');
    }
    const CONTACT_PATCH_FIELDS = _lodash.default.chain(patchContactData).omit('contactId').keys().value();

    // eslint-disable-next-line no-unused-vars
    for (const property of CONTACT_PATCH_FIELDS) {
      if (_lodash.default.get(patchContactData, [property, `removeAll${_lodash.default.upperFirst(property)}`])) {
        contactData[property] = [];
        continue;
      }
      const dataToAdd = _lodash.default.get(patchContactData, [property, `add${_lodash.default.upperFirst(property)}`]);
      if (!_lodash.default.isEmpty(dataToAdd)) {
        const existedData = contactData[property];
        if (_lodash.default.isString(dataToAdd[0])) {
          contactData[property] = _lodash.default.uniq(_lodash.default.concat(existedData, dataToAdd));
        } else {
          // eslint-disable-next-line no-unused-vars
          for (const identifier of dataToAdd) {
            const existedIdentifierIdx = _lodash.default.findIndex(existedData, existedIdnt => existedIdnt.val === identifier.val);
            if (existedIdentifierIdx !== -1) {
              existedData[existedIdentifierIdx] = {
                val: identifier.val,
                type: _lodash.default.uniq(_lodash.default.concat(existedData[existedIdentifierIdx].type, identifier.type))
              };
            } else {
              existedData.push(identifier);
            }
          }
          contactData[property] = existedData;
        }
      }
      const dataToRemove = _lodash.default.get(patchContactData, [property, `remove${_lodash.default.upperFirst(property)}`]);
      if (!_lodash.default.isEmpty(dataToRemove)) {
        const existedData = contactData[property];
        if (_lodash.default.isString(dataToRemove[0])) {
          contactData[property] = _lodash.default.difference(existedData, dataToRemove);
        } else {
          contactData[property] = _lodash.default.differenceBy(existedData, dataToRemove, 'val');
        }
      }
    }
    return await this._callApi({
      method: 'put',
      path: '/contacts',
      queryParams: {
        returning,
        bookName
      },
      payload: contactData,
      errorName: 'ContactError'
    });
  }

  /**
   *
   * @param {Object} param0.contactData contact object
   * @param {String} param1.bookName name of contact book
   */
  async createContact(_ref6) {
    let {
      contactData,
      bookName
    } = _ref6;
    return await this._callApi({
      method: 'post',
      path: '/contacts',
      queryParams: {
        bookName
      },
      payload: contactData,
      errorName: 'ContactError'
    });
  }

  /**
   *
   * @param {String} param0.toContact id of contact that main in merge
   * @param {String} param1.fromContacts id of contact that got to be delete after merge
   * @param {String} param2.bookName name of contact book
   */
  async mergeContacts(_ref7) {
    let {
      toContact,
      fromContacts,
      bookName
    } = _ref7;
    return await this._callApi({
      method: 'post',
      path: '/contacts/merge',
      payload: {
        toContact,
        fromContacts,
        bookName
      },
      errorName: 'ContactError'
    });
  }

  /**
   *
   * @param {String} param0.bookName name of contact book
   * @param {Object} param1.searchData fields for query and options for request
   * @param {Integer} param2.v version of search
   * @param {String} param3.searchPhrase string for full-text search
   * @param {String} param4.filterId id of filter for filter search
   * @param {Object} param5.searchProps fields for search query
   * @param {Boolean} param6.matchIdentifiersExactly
   * @param {Integer} param7.size a number of contacts to receive
   * @param {Integer} param8.from a number of first contact from the list
   * @param {String} param9.sort sorting method
   * @param {Object} param10.projection projection for get specified fields
   * @param {Boolean} param11.useAlias if true - match contactId with aliases
   * @returns {Array} of contacts
   */
  async searchContacts(_ref8) {
    let {
      bookName,
      searchData,
      v,
      searchPhrase,
      filterId,
      searchProps,
      matchIdentifiersExactly,
      from,
      size,
      sort,
      scroll_id,
      scroll,
      projection,
      useAlias
    } = _ref8;
    const contactsBody = v !== 2 ? searchData : {
      searchPhrase,
      filterId,
      v,
      searchProps,
      matchIdentifiersExactly,
      from,
      size,
      sort,
      scroll_id,
      scroll,
      projection,
      useAlias
    };
    return await this._callApi({
      method: 'post',
      path: '/contacts/search',
      payload: contactsBody,
      queryParams: {
        bookName
      },
      errorName: 'ContactError'
    });
  }

  /**
   *
   * @param {String} param0.projection projection for get specified fields
   * @param {String} param1.bookName name of contact book
   */
  async getUsersList() {
    let {
      projection,
      bookName
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return await this._callApi({
      method: 'get',
      path: '/contacts/users',
      queryParams: {
        projection,
        bookName
      },
      errorName: 'ContactsUserError'
    });
  }

  /**
   *
   * @param {String} param0.userId id of user
   * @param {Array} param1.contactRuleGroups rule groups for user
   * @param {String} param2.bookName name of contact book
   * @param {String} param3.userAccountId accountId of user
   */
  async updateUserContactRuleGroups(_ref9) {
    let {
      userId,
      contactRuleGroups,
      bookName,
      userAccountId
    } = _ref9;
    return await this._callApi({
      method: 'put',
      path: '/contacts/users',
      queryParams: {
        userId
      },
      payload: {
        contactRuleGroups,
        bookName,
        userAccountId
      },
      errorName: 'UserContactRuleGroupsError'
    });
  }

  /**
   * @param {String} param0.userId userId
   * @param {Array} param1.addContactRuleGroups array of groups ids add to user groups
   * @param {Array} param2.removeContactRuleGroups array of groups ids remove to user groups
   * @param {String} param3.bookName name of contact book
   * @param {String} param4.userAccountId accountId of user
   * @returns {Object} user groups
   */
  async patchUserContactRuleGroups(_ref10) {
    let {
      userId,
      addContactRuleGroups,
      removeContactRuleGroups,
      bookName,
      userAccountId
    } = _ref10;
    return await this._callApi({
      method: 'patch',
      path: '/contacts/users',
      queryParams: {
        userId
      },
      payload: {
        addContactRuleGroups,
        removeContactRuleGroups,
        bookName,
        userAccountId
      },
      errorName: 'UserContactRuleGroupsError'
    });
  }

  /**
   *
   * @param {String} param0.searchPhrase string for full-text search
   * @param {Integer} param1.size a number of rule groups to receive
   * @param {Integer} param2.from a number of first rule group from the list
   * @param {String} param3.sort sorting method
   * @param {Object} param4.projection projection for get specified fields
   * @returns {Array} rule groups list
   */
  async getContactRuleGroupsList(_ref11) {
    let {
      searchPhrase,
      size,
      from,
      sort,
      projection
    } = _ref11;
    return await this._callApi({
      method: 'get',
      path: '/contacts/rule-groups',
      queryParams: {
        searchPhrase,
        size,
        from,
        sort,
        projection
      },
      errorName: 'ContactRuleGroupsError'
    });
  }

  /**
   * @param {String} param0.groupId id of rule group
   * @returns {Object} rule group
   */
  async getContactRuleGroup(_ref12) {
    let {
      groupId
    } = _ref12;
    return await this._callApi({
      method: 'get',
      path: '/contacts/rule-groups',
      queryParams: {
        groupId
      },
      errorName: 'ContactRuleGroupsError'
    });
  }

  /**
   * @param {String} param0.name name of rule group
   * @param {Array} param1.rules user permissions rules
   * @returns {Object} add stats
   */
  async addContactRuleGroup(_ref13) {
    let {
      name,
      rules
    } = _ref13;
    return await this._callApi({
      method: 'post',
      path: '/contacts/rule-groups',
      payload: {
        name,
        rules
      },
      errorName: 'ContactRuleGroupsError'
    });
  }

  /**
   * @param {String} param0.groupId id of rule group
   * @param {String} param1.name name of rule group
   * @param {Array} param2.rules user permissions rules
   * @returns {Object} update stats
   */
  async updateContactRuleGroup(_ref14) {
    let {
      groupId,
      name,
      rules
    } = _ref14;
    return await this._callApi({
      method: 'put',
      path: '/contacts/rule-groups',
      payload: {
        groupId,
        name,
        rules
      },
      errorName: 'ContactRuleGroupsError'
    });
  }

  /**
   * @param {String} param0.groupId id of rule group
   * @returns {Object} delete stats
   */
  async deleteContactRuleGroup(_ref15) {
    let {
      groupId
    } = _ref15;
    return await this._callApi({
      method: 'delete',
      path: '/contacts/rule-groups',
      queryParams: {
        groupId
      },
      errorName: 'ContactRuleGroupsError'
    });
  }

  /**
   *  @param {String} param0.bookName name of contact book with filters
   * @returns {Array} filters list
   */
  async getContactFiltersList(_ref16) {
    let {
      bookName
    } = _ref16;
    return await this._callApi({
      method: 'get',
      path: '/contacts/filters',
      queryParams: {
        bookName
      },
      errorName: 'ContactFiltersError'
    });
  }

  /**
   * @param {String} param0.filterId id of filter
   * @returns {Object} filter
   */
  async getContactFilter(_ref17) {
    let {
      filterId
    } = _ref17;
    return await this._callApi({
      method: 'get',
      path: '/contacts/filters',
      queryParams: {
        filterId
      },
      errorName: 'ContactFiltersError'
    });
  }

  /**
   * @param {String} param0.name name of filter
   * @param {String} param1.bookName name of contact book
   * @param {Array} param2.conditions array of conditions (array of objects {property, operator, value})
   * @param {Boolean} param3.matchAllCondition if true filter match all conditions if false any of them
   * @returns {Object} add stats
   */
  async addContactFilter(_ref18) {
    let {
      name,
      bookName,
      conditions,
      matchAllConditions
    } = _ref18;
    return await this._callApi({
      method: 'post',
      path: '/contacts/filters',
      payload: {
        name,
        conditions,
        bookName,
        matchAllConditions
      },
      errorName: 'ContactFiltersError'
    });
  }

  /**
   * @param {String} param0.filterId id of filter
   * @param {String} param1.name name of filter
   * @param {Array} param2.conditions array of conditions (array of objects {property, operator, value})
   * @param {Boolean} param3.matchAllCondition if true filter match all conditions if false any of them
   * @returns {Object} empty object
   */
  async updateContactFilter(_ref19) {
    let {
      filterId,
      name,
      conditions,
      matchAllConditions
    } = _ref19;
    return await this._callApi({
      method: 'put',
      path: '/contacts/filters',
      payload: {
        filterId,
        name,
        conditions,
        matchAllConditions
      },
      errorName: 'ContactFiltersError'
    });
  }

  /**
   * @param {String} param0.filterId id of filter
   * @returns {Object} empty object
   */
  async deleteContactFilter(_ref20) {
    let {
      filterId
    } = _ref20;
    return await this._callApi({
      method: 'delete',
      path: '/contacts/filters',
      queryParams: {
        filterId
      },
      errorName: 'ContactFiltersError'
    });
  }

  /**
   * @param {String} param0.bookName name of contacts book
   * @returns {Object} number of records
   */
  async getContactRecordsCount(_ref21) {
    let {
      bookName
    } = _ref21;
    return await this._callApi({
      method: 'get',
      path: '/contacts/count',
      queryParams: {
        bookName
      },
      errorName: 'ContactRecordCountError'
    });
  }

  /**
   *
   * @returns {Object} {checkContactsInstalled: true or false}
   */
  async checkContactsInstalled() {
    return await this._callApi({
      method: 'get',
      path: '/contacts/check',
      errorName: 'ContactError'
    });
  }

  /**
   * @param {String} param0.tableName name of contacts table
   * @param {Boolean} param1.isService for service tables migrations
   * @returns {Object} last migration data
   */
  async getLastMigrationVersion(_ref22) {
    let {
      tableName,
      isService
    } = _ref22;
    return await this._callApi({
      method: 'get',
      path: '/contacts/last-migration-version',
      queryParams: {
        tableName,
        isService
      },
      errorName: 'ContactError'
    });
  }

  /**
   * @returns {Object} {checkMigrationsNeeded: true or false}
   */
  async checkIfMigrationsNeeded() {
    return await this._callApi({
      method: 'get',
      path: 'contacts-tables/service/migrations',
      errorName: 'ServiceMigrationError'
    });
  }

  /**
   *
   * @returns {Object} deployed contacts versions
   */
  async getDeployedContactsVersion() {
    return await this._callApi({
      method: 'get',
      path: '/contacts/deployed-versions',
      errorName: 'ContactError'
    });
  }
}
var _default = ContactsApi;
exports.default = _default;